/**
 * Clinic-level presentation switch for Online Booking.
 *
 * This does NOT decide eligibility or availability. Those stay:
 *   show_in_booking ∩ service practitioner eligibility ∩ working hours
 *   ∩ exceptions ∩ existing appointments ∩ resources ∩ notice/window.
 *
 * Default true preserves the current patient-facing practitioner UI for
 * clinics that have not set the new column yet.
 */
export const DEFAULT_SHOW_PRACTITIONERS_IN_ONLINE_BOOKING = true;

export function parseShowPractitionersInOnlineBooking(
  value: boolean | null | undefined,
): boolean {
  if (value === false) return false;
  return DEFAULT_SHOW_PRACTITIONERS_IN_ONLINE_BOOKING;
}

export function onlineBookingStepsWithoutHiddenPractitioner<T extends string>(
  steps: readonly T[],
  showPractitioners: boolean,
): T[] {
  if (showPractitioners) return [...steps];
  return steps.filter((step) => step !== 'clinician');
}

/** When names are hidden, the slot's assigned clinician is the booking target. */
export function clinicianIdForOnlineBooking(input: {
  showPractitioners: boolean;
  anyClinicianSelected: boolean;
  selectedClinicianId: string | null | undefined;
  slotClinicianId: string;
}): string {
  if (!input.showPractitioners || input.anyClinicianSelected) {
    return input.slotClinicianId;
  }
  return input.selectedClinicianId ?? input.slotClinicianId;
}
